<script lang="ts">
  /** Inline icon set — no runtime icon fetching, everything ships in the bundle. */
  import type { IconName } from "../icons";

  const { name, size = 20 }: { name: IconName; size?: number | string } =
    $props();

  const PLANE =
    "M21 12c0 .6-.4 1-1 1.1l-5.5.9-2.6 5.4c-.2.4-.5.6-.9.6H9.6c-.5 0-.8-.4-.7-.9l1.2-5-3.4.6-1.1 1.6c-.2.2-.4.3-.6.3H4c-.4 0-.7-.4-.6-.8L4.2 12l-.8-2.8c-.1-.4.2-.8.6-.8h1c.2 0 .4.1.6.3l1.1 1.6 3.4.6-1.2-5c-.1-.5.2-.9.7-.9h1.4c.4 0 .7.2.9.6l2.6 5.4 5.5.9c.6.1 1 .5 1 1.1z";

  /** The colour-blind toggle: the same three shapes the world uses. */
  const SHAPE_TRIANGLE = "M11.6 2.6 16.6 11H6.6z";
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  {#if name === "plane"}
    <path d={PLANE} fill="currentColor" stroke="none" />
  {:else if name === "plane-arrival"}
    <g transform="rotate(24 12 11)"
      ><path
        d={PLANE}
        fill="currentColor"
        stroke="none"
        transform="scale(0.86) translate(2 1)"
      /></g
    >
    <path d="M3 21h18" />
  {:else if name === "plane-departure"}
    <g transform="rotate(-24 12 11)"
      ><path
        d={PLANE}
        fill="currentColor"
        stroke="none"
        transform="scale(0.86) translate(2 1)"
      /></g
    >
    <path d="M3 21h18" />
  {:else if name === "bolt"}
    <path
      d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12z"
      fill="currentColor"
      stroke="none"
    />
  {:else if name === "clock"}
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5.2l3.4 2" />
  {:else if name === "arrow-down"}
    <path d="M12 4v15" />
    <path d="m6 13.5 6 6 6-6" />
  {:else if name === "arrow-up"}
    <path d="M12 20V5" />
    <path d="m6 10.5 6-6 6 6" />
  {:else if name === "pause"}
    <path d="M8.5 4.5v15M15.5 4.5v15" stroke-width="3" />
  {:else if name === "play"}
    <path d="M7 4.5 20 12 7 19.5z" fill="currentColor" stroke="none" />
  {:else if name === "sound-on"}
    <path
      d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"
      fill="currentColor"
      stroke="none"
    />
    <path d="M15.5 9a4.2 4.2 0 0 1 0 6" />
    <path d="M18.5 6.2a8 8 0 0 1 0 11.6" />
  {:else if name === "sound-off"}
    <path
      d="M4 9.5h3.5L12 5.5v13L7.5 14.5H4z"
      fill="currentColor"
      stroke="none"
    />
    <path d="m16 9.5 5 5M21 9.5l-5 5" />
  {:else if name === "rotate-left"}
    <path d="M4.5 6.5v5h5" />
    <path d="M5.2 11.5a7.5 7.5 0 1 1 .8 5.6" />
  {:else if name === "rotate-right"}
    <path d="M19.5 6.5v5h-5" />
    <path d="M18.8 11.5a7.5 7.5 0 1 0-.8 5.6" />
  {:else if name === "eye"}
    <path
      d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"
    />
    <circle cx="12" cy="12" r="3" />
  {:else if name === "eye-off"}
    <path d="M4 4.5 20 19.5" />
    <path
      d="M9.6 6.1A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.3 4"
    />
    <path
      d="M6.4 8.2A17.6 17.6 0 0 0 2.5 12S6 18.5 12 18.5c1.2 0 2.3-.2 3.3-.6"
    />
  {:else if name === "shapes"}
    <path d={SHAPE_TRIANGLE} fill="currentColor" stroke="none" />
    <circle cx="6.6" cy="17" r="3.7" fill="currentColor" stroke="none" />
    <rect
      x="13.6"
      y="13.3"
      width="7.4"
      height="7.4"
      rx="0.6"
      fill="currentColor"
      stroke="none"
    />
  {:else if name === "trophy"}
    <path d="M7.4 4.2h9.2v5a4.6 4.6 0 0 1-9.2 0z" />
    <path d="M7.4 5.6H4.9v1.5a3 3 0 0 0 3 3" />
    <path d="M16.6 5.6h2.5v1.5a3 3 0 0 1-3 3" />
    <path d="M12 13.8v3.4M8.8 20h6.4l-.8-2.8H9.6z" />
  {:else if name === "settings"}
    <circle cx="12" cy="12" r="3.1" />
    <path
      d="M12 2.6l1.5 2.2 2.6-.5.6 2.6 2.4 1.1-1.2 2.4 1.2 2.4-2.4 1.1-.6 2.6-2.6-.5L12 21.4l-1.5-2.2-2.6.5-.6-2.6-2.4-1.1 1.2-2.4-1.2-2.4 2.4-1.1.6-2.6 2.6.5z"
    />
  {:else if name === "zoom-in"}
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="m15.4 15.4 5.1 5.1" />
    <path d="M10.5 7.6v5.8M7.6 10.5h5.8" />
  {:else if name === "zoom-out"}
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="m15.4 15.4 5.1 5.1" />
    <path d="M7.6 10.5h5.8" />
  {:else if name === "shapes-off"}
    <path d={SHAPE_TRIANGLE} stroke-width="1.7" />
    <circle cx="6.6" cy="17" r="3.7" stroke-width="1.7" />
    <rect
      x="13.6"
      y="13.3"
      width="7.4"
      height="7.4"
      rx="0.6"
      stroke-width="1.7"
    />
  {/if}
</svg>

<style>
  svg {
    display: block;
  }
</style>
